import cx from 'classnames';
import ItemNoPlate from '../../../ItemNoPlate/ItemNoPlate';
import ActionsDirective from '../ActionsDirective';
import Title from '../Title';
import styles from './Item.module.scss';
import { getLeafCategoryForItem } from '../../../../utils/tree/treeNode';
import type { NodeItem } from '../../../../entities/Node';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { selectCatalog } from '../../../../store/slices/catalog';
import { CATALOG_TYPE_MISSINGITEMS } from '../../../../utils/types/catalogTypes';
import { HoverActions } from '../../HoverActions/HoverActions';
import { useHoverActions } from '../../HoverActions/useHoverActions';

const Item = ({ node, hover = true }: { node: NodeItem; hover?: boolean }) => {
  const leafCategoryId = getLeafCategoryForItem(node.parentId);
  const catalog = useSelector((state: RootState) =>
    selectCatalog(state, node.catalogId),
  );

  const showHoverActions = useHoverActions(node, hover);

  const { inDraft, itemNoFormated, title } = node;

  return (
    <ActionsDirective node={node}>
      <div
        className={cx(styles.titleWrapper, {
          'u-color-lightest': inDraft,
          'u-line-through': inDraft,
          [styles.singleItem]: node.isLeaf && hover,
        })}
      >
        <ItemNoPlate
          showRelations={node.item.mainParent !== undefined}
          isMainItem={leafCategoryId === node.item.mainParent}
          itemNoFormated={itemNoFormated || ''}
          isMissingItem={catalog?.catalogType === CATALOG_TYPE_MISSINGITEMS}
        />
        {node.item.itemType === 'SPR' && <div className={styles.sprItem}>SPR</div>}
        <Title className={styles.ellipsis} title={title} />
      </div>
      {showHoverActions && <HoverActions node={node} />}
    </ActionsDirective>
  );
};

export default Item;
